export default __webpack_public_path__ + "static/media/spell3.b4624bbe.jpg";